/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { Component, PropTypes } from 'react';
import { Modal, ModalFooter, ModalHeader, Button, Container } from '../../Common/reactstrap/lib';
/*
 * @var id
 * @var name
 * @var userId
 * function:submitDelete(date) set @vars to parent component
 * */
class ModalDelete extends React.Component {
  constructor(props) {
    super(props);

    this.submitDelete = this.submitDelete.bind(this);
  }

  submitDelete() {
    this.props.submitDelete({[this.props.name]: this.props.id});
    this.props.close();
  }

  render() {
    return (
      <Modal isOpen={this.props.visible} toggle={this.props.close} className={this.props.className}>
        <ModalHeader toggle={this.props.close}>{this.props.text}</ModalHeader>
        <Container>
        </Container>
        <ModalFooter>
          <Button onClick={this.props.close}>Нет</Button><Button color="primary" onClick={this.submitDelete}>Да</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

ModalDelete.propTypes = {
  isOpen:  PropTypes.bool,

  toggle:  PropTypes.func,

  size: PropTypes.string,

  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,

  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default ModalDelete;



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/ModalDelete.jsx
 **/